<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
    <g transform="translate(-381 -920)">
      <rect
        width="1"
        height="21"
        transform="translate(384 920)"
        fill="#777"
      />
      <rect
        width="1"
        height="21"
        transform="translate(388 920)"
        fill="#777"
      />
      <rect
        width="1"
        height="21"
        transform="translate(392 920)"
        fill="#777"
      />
      <rect
        width="1"
        height="21"
        transform="translate(396 920)"
        fill="#777"
      />
      <rect
        width="1"
        height="21"
        transform="translate(400 920)"
        fill="#777"
      />
      <rect
        width="23"
        height="1"
        transform="translate(381 922)"
        fill="#777"
      />
      <rect
        width="23"
        height="1"
        transform="translate(381 926)"
        fill="#777"
      />
      <rect
        width="23"
        height="1"
        transform="translate(381 930)"
        fill="#777"
      />
      <rect
        width="23"
        height="1"
        transform="translate(381 934)"
        fill="#777"
      />
      <rect
        width="23"
        height="1"
        transform="translate(381 938)"
        fill="#777"
      />
    </g>
  </svg>
</template>
